import { get, post, remove, put } from "../../utils/httpClient";

const commentService = () => {
  const prefixApi = "duedates/comments";

  const getComments = async (taskId) => {
    return await get(`/${prefixApi}/task`, { taskId: taskId });
  };

  const getCommentsCount = async (taskId) => {
    return await get(`/${prefixApi}/count`, { taskId: taskId });
  };

  const getComment = async (id) => {
    return await get(`/${prefixApi}/${id}`);
  };

  const createComment = async (json) => {
    return await post(`/${prefixApi}`, json);
  };

  const updateComment = async (json) => {
    return await put(`/${prefixApi}`, json);
  };

  const deleteComment = async (id) => {
    return await remove(`/${prefixApi}/${id}`);
  };

  return {
    getComments,
    getCommentsCount,
    getComment,
    createComment,
    updateComment,
    deleteComment,
  };
};

export default commentService;
